import { useLocation } from "wouter";
import { getEnglishPathForArabicPath, getLocalisedRoute, localeFromPath, normalizeLocalePath } from "@/i18n/localisedRoutes";

/**
 * Native language switcher. It never routes visitors through a Google Translate
 * proxy and never pretends an untranslated English page has an Arabic equivalent.
 */
export default function ArabicToggle() {
  const [location, setLocation] = useLocation();
  const normalized = normalizeLocalePath(location);
  const locale = localeFromPath(normalized);
  const route = getLocalisedRoute(normalized);

  const switchLanguage = () => {
    const params = new URLSearchParams(window.location.search);
    const retained = new URLSearchParams();
    params.forEach((value, key) => {
      if (key.startsWith("utm_")) retained.set(key, value);
    });
    const search = retained.toString() ? `?${retained.toString()}` : "";
    const destination = locale === "ar"
      ? getEnglishPathForArabicPath(normalized) ?? "/"
      : route?.arPath ?? "/ar/";
    setLocation(`${destination}${search}`);
  };

  const isArabic = locale === "ar";
  return (
    <button
      onClick={switchLanguage}
      aria-label={isArabic ? "Switch to English" : "التبديل إلى العربية"}
      title={isArabic ? "Switch to English" : "العربية"}
      style={{
        position: "fixed",
        bottom: "88px",
        insetInlineEnd: "20px",
        zIndex: 9000,
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        background: "rgba(13,17,23,0.88)",
        border: "1.5px solid rgba(255,255,255,0.22)",
        color: "rgba(255,255,255,0.9)",
        fontSize: isArabic ? "13px" : "18px",
        fontFamily: "Tahoma, 'Noto Naskh Arabic', 'Amiri', sans-serif",
        lineHeight: 1,
        cursor: "pointer",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
        transition: "background 200ms ease-out, border-color 200ms ease-out, color 200ms ease-out, transform 160ms ease-out",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
      }}
      onMouseEnter={(event) => { event.currentTarget.style.background = "rgba(30,40,55,0.95)"; event.currentTarget.style.borderColor = "rgba(255,140,0,0.65)"; }}
      onMouseLeave={(event) => { event.currentTarget.style.background = "rgba(13,17,23,0.88)"; event.currentTarget.style.borderColor = "rgba(255,255,255,0.22)"; }}
      onMouseDown={(event) => { event.currentTarget.style.transform = "scale(0.93)"; }}
      onMouseUp={(event) => { event.currentTarget.style.transform = "scale(1)"; }}
    >
      {isArabic ? "EN" : "ع"}
    </button>
  );
}
